/**
 * variants/solid/ActionIcons.jsx
 * Common action SVG glyphs for Homy in "obsidian-solid" variant.
 */

import * as React from "react";

function createSvgIcon(name, renderPaths) {
  const Component = React.forwardRef(
    ({ size, width, height, className = "", embedded = false, ...props }, ref) => {
      const dimension = size || width || 24;

      if (embedded) {
        return (
          <g
            ref={ref}
            fill="currentColor"
            stroke="none"
            className={className}
            data-icon={name}
            {...props}
          >
            {renderPaths()}
          </g>
        );
      }

      return (
        <svg
          ref={ref}
          viewBox="0 0 24 24"
          width={dimension}
          height={height || dimension}
          fill="currentColor"
          className={className}
          data-icon={name}
          xmlns="http://www.w3.org/2000/svg"
          {...props}
        >
          {renderPaths()}
        </svg>
      );
    }
  );
  Component.displayName = name;
  return Component;
}

export const PlusIcon = createSvgIcon("PlusIcon", () => (
  <path
    fillRule="evenodd"
    clipRule="evenodd"
    d="M12 2a10 10 0 1 0 0 20 10 10 0 0 0 0-20zm1 5h-2v4H7v2h4v4h2v-4h4v-2h-4V7z"
  />
));

export const EditIcon = createSvgIcon("EditIcon", () => (
  <path
    fillRule="evenodd"
    clipRule="evenodd"
    d="M3 17.25V21h3.75L17.81 9.94l-3.75-3.75L3 17.25zM20.71 7.04a1 1 0 0 0 0-1.41l-2.34-2.34a1 1 0 0 0-1.41 0l-1.83 1.83 3.75 3.75 1.83-1.83z"
  />
));

export const TrashIcon = createSvgIcon("TrashIcon", () => (
  <path
    fillRule="evenodd"
    clipRule="evenodd"
    d="M6 19a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V7H6v12zM19 4h-3.5l-1-1h-5l-1 1H5v2h14V4z"
  />
));

export const SearchIcon = createSvgIcon("SearchIcon", () => (
  <path
    fillRule="evenodd"
    clipRule="evenodd"
    d="M10 2a8 8 0 1 0 5.29 14l4.7 4.71 1.42-1.42-4.7-4.7A8 8 0 0 0 10 2zm-6 8a6 6 0 1 1 12 0 6 6 0 0 1-12 0z"
  />
));

export const FilterIcon = createSvgIcon("FilterIcon", () => (
  <polygon points="22 3 2 3 10 12.46 10 19 14 21 14 12.46 22 3" />
));

export const CloseIcon = createSvgIcon("CloseIcon", () => (
  <path
    fillRule="evenodd"
    clipRule="evenodd"
    d="M12 2a10 10 0 1 0 0 20 10 10 0 0 0 0-20zm3.7 12.3l-1.4 1.4-2.3-2.3-2.3 2.3-1.4-1.4 2.3-2.3-2.3-2.3 1.4-1.4 2.3 2.3 2.3-2.3 1.4 1.4-2.3 2.3 2.3 2.3z"
  />
));

export const CheckIcon = createSvgIcon("CheckIcon", () => (
  <path
    fillRule="evenodd"
    clipRule="evenodd"
    d="M12 2a10 10 0 1 0 0 20 10 10 0 0 0 0-20zm4.7 7.3l-5.7 5.7-2.7-2.7 1.4-1.4 1.3 1.3 4.3-4.3 1.4 1.4z"
  />
));

export const ChevronLeftIcon = createSvgIcon("ChevronLeftIcon", () => (
  <path
    fillRule="evenodd"
    clipRule="evenodd"
    d="M15.41 16.59L10.83 12l4.58-4.59L14 6l-6 6 6 6 1.41-1.41z"
  />
));

export const ChevronRightIcon = createSvgIcon("ChevronRightIcon", () => (
  <path
    fillRule="evenodd"
    clipRule="evenodd"
    d="M8.59 16.59L13.17 12 8.59 7.41 10 6l6 6-6 6-1.41-1.41z"
  />
));

export const ChevronDownIcon = createSvgIcon("ChevronDownIcon", () => (
  <path
    fillRule="evenodd"
    clipRule="evenodd"
    d="M7.41 8.59L12 13.17l4.59-4.58L18 10l-6 6-6-6 1.41-1.41z"
  />
));

export const ChevronUpIcon = createSvgIcon("ChevronUpIcon", () => (
  <path
    fillRule="evenodd"
    clipRule="evenodd"
    d="M7.41 15.41L12 10.83l4.59 4.58L18 14l-6-6-6 6 1.41 1.41z"
  />
));

export const solidActionGlyphs = {
  plus: PlusIcon,
  edit: EditIcon,
  trash: TrashIcon,
  search: SearchIcon,
  filter: FilterIcon,
  close: CloseIcon,
  check: CheckIcon,
  "chevron-left": ChevronLeftIcon,
  "chevron-right": ChevronRightIcon,
  "chevron-down": ChevronDownIcon,
  "chevron-up": ChevronUpIcon,
};
